import {
  Activity,
  BarChart3,
  Boxes,
  ShieldCheck,
} from "lucide-react";
import type { ViewId } from "../types";

type PlaceholderViewProps = {
  view: Exclude<ViewId, "agent" | "qodes" | "beta">;
};

const viewContent = {
  deployments: {
    title: "Deployments",
    description: "把数字入口与现实中的包装、海报、设备、地点和批次连接起来。",
    icon: Boxes,
    metric: "512",
    label: "已登记现实载体",
  },
  incidents: {
    title: "Incidents",
    description: "按影响范围管理入口故障、安全异常和受控修复。",
    icon: Activity,
    metric: "1",
    label: "正在处理的事件",
  },
  insights: {
    title: "Insights",
    description: "从扫描数量走向健康、风险、转化和持续行动。",
    icon: BarChart3,
    metric: "98.7%",
    label: "本周入口健康度",
  },
  governance: {
    title: "Governance",
    description: "统一管理权限、审批、域名、策略和不可变审计记录。",
    icon: ShieldCheck,
    metric: "34",
    label: "受策略保护的入口",
  },
};

export function PlaceholderView({ view }: PlaceholderViewProps) {
  const content = viewContent[view];
  const Icon = content.icon;

  return (
    <div className="page placeholder-page">
      <section className="page-heading">
        <div>
          <h1>{content.title}</h1>
          <p>{content.description}</p>
        </div>
      </section>
      <section className="placeholder-surface">
        <Icon size={26} />
        <strong>{content.metric}</strong>
        <span>{content.label}</span>
        <p>该模块已纳入 Qode Agent MVP 开发计划。</p>
      </section>
    </div>
  );
}
